@if(hasBackground){
<!-- Overlay Style with Background -->
<div
  class="absolute inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center z-50"
>
  <div
    class="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"
  ></div>
</div>

} @else {
<!-- Overlay Style with NO Background -->
<div class="flex items-center justify-center h-full w-full">
  <div
    class="w-8 h-8 border-3 border-t-transparent border-light-300 rounded-full animate-spin"
  ></div>
</div>
}
